export { default } from './ProviderAdd'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Provider/ProviderAdd/index.js